

        jQuery(function() {
            var $module = jQuery('#m-1526301433237').children('.module');
            $module.find('.counter').counterUp({
                delay: 10,
                time: 1000
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1526301456626').children('.module');

        }); 
    